module.exports = __webpack_public_path__ + "static/img/IMG-20150730-WA0001.2e99cef2.jpg";